  export function colorByPercentage(percentage: number) {
    if (percentage === 0) {
      return '#FFFFFF';
    }

    const value = Math.max(0, Math.min(100, percentage));

    const normalized = value / 100;

    const red = Math.round(normalized * 255);
    const blue = Math.round((1 - normalized) * 255);
    const green = 0;

    const toHex = (n: any) => n.toString(16).padStart(2, '0');

    return `#${toHex(red)}${toHex(green)}${toHex(blue)}DD`;
  }
